// Simplified API wrapper to avoid TypeScript deep instantiation issues
const convexApi = require('../convex/_generated/api');

// Export api with simplified typing
export const api = convexApi.api;